import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { hoverDefault } from '../../../utils/styles';

const Styled = styled.div``;

const StyledLink = styled.a`
  ${hoverDefault};
  color: ${props => props.theme.colorMinor};
  text-decoration: none;
`;

const Awards = ({ className, items }) => (
  <Styled className={className}>
    <div>Награды:</div>
    {items.map((item, index) => (
      <div key={index}>
        <StyledLink href={item.url} target="_blank">
          {item.name}
        </StyledLink>
      </div>
    ))}
  </Styled>
);

Awards.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Awards;



// WEBPACK FOOTER //
// ./src/scenes/Case/components/Awards.js